// Identity rules shared by the browser API and the server emitter (ADR #952):
// userId is the Auth0 database id with its "auth0|" prefix stripped; any other
// provider keeps the full subject. The full subject always travels as traits.auth0Id.
import contract from '../contract/segment-events.json' with { type: 'json' };

const USER_ID_PATTERN = new RegExp(contract.identity.user_id_pattern);
const DATABASE_PREFIX = 'auth0|';

export interface ResolvedUser {
  userId: string;
  auth0Id: string;
}

export function resolveUserId(auth0Id: string | null | undefined): ResolvedUser | null {
  if (typeof auth0Id !== 'string') return null;
  const trimmed = auth0Id.trim();
  const userId = trimmed.startsWith(DATABASE_PREFIX) ? trimmed.slice(DATABASE_PREFIX.length) : trimmed;
  return USER_ID_PATTERN.test(userId) ? { userId, auth0Id: trimmed } : null;
}
